import { Route, Routes } from 'react-router';

import { FWDCURVE_CATALOG_PATH, SPOT_CATALOG_PATH } from '@/constants/constants';
import PersonalizationVariantRenderer from '@/features/ComponentVariants/PersonalizationVariantRenderer';
import MainLayout from '@/layouts/MainLayout';
import ProtectedLayout from '@/layouts/ProtectedLayout';
import UnprotectedLayout from '@/layouts/UnprotectedLayout';
import Catalog from '@/pages/Catalog';
import DataHub from '@/pages/DataHub';
import { FACTSHEET_PARAM_NAME } from '@/pages/Facthsheets/constants';
import Home from '@/pages/Home';
import Logout from '@/pages/Logout';
import Lookup from '@/pages/Lookup';
import Markets from '@/pages/Markets';
import NotFound from '@/pages/NotFound';
import Login from '@/pages/Onboarding/features/Login';
import OnboardingForm from '@/pages/Onboarding/OnboardingForm';
import Profile from '@/pages/Profile';
import ManageSubscription from '@/pages/Subscription';
import SubscriptionSuccess from '@/pages/Subscription/components/SubscriptionSuccess';

import FileDownload from './pages/FileDownload';
import Onboarding from './pages/Onboarding';
import Welcome from './pages/Welcome';

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        element={<Onboarding />}
        path='/onboarding'
      />
      <Route
        element={<Login />}
        path='/login'
      />
      <Route
        element={<OnboardingForm />}
        path='/onboarding/form'
      />
      <Route
        element={<Logout />}
        path='/logout'
      />

      <Route element={<UnprotectedLayout />}>
        <Route
          index
          element={<Home />}
        />
        <Route
          element={<Home />}
          path='/token'
        />
        <Route
          element={<Lookup />}
          path={`/:${FACTSHEET_PARAM_NAME}`}
        />
        <Route element={<ProtectedLayout />}>
          <Route
            element={<Welcome />}
            path='/welcome'
          />
          <Route
            element={<FileDownload />}
            path='/file/:fileName/:fileId'
          />
          <Route element={<MainLayout />}>
            <Route
              element={<Markets />}
              path='/markets'
            />

            <Route
              element={<Markets />}
              path='/markets/:marketId'
            />
            <Route
              element={<Markets />}
              path='markets/:marketId/:tabId'
            />
            <Route
              element={<Catalog />}
              path={`/catalog/${SPOT_CATALOG_PATH}`}
            />
            <Route
              element={<Catalog />}
              path={`/catalog/${FWDCURVE_CATALOG_PATH}`}
            />
            <Route
              element={<DataHub />}
              path='/data-hub'
            >
              <Route path='*' />
            </Route>
            <Route
              element={<Profile />}
              path='/profile'
            />
            <Route
              element={<ManageSubscription />}
              path='/manage-subscription'
            />
            <Route
              element={<PersonalizationVariantRenderer componentName='dashboard_route_element' />}
              path='/dashboard/:dashboardId?'
            />
          </Route>
          <Route
            element={<SubscriptionSuccess />}
            path='/subscription/success'
          />
        </Route>
      </Route>
      <Route
        element={<NotFound />}
        path='/notfound'
      />
      <Route
        element={<NotFound />}
        path='/:section/*'
      />
      <Route
        element={<NotFound />}
        path='*'
      />
    </Routes>
  );
};

export default AppRoutes;
